import React from 'react';
import Paper from '@material-ui/core/Paper';
import { Typography } from '@material-ui/core';
import { getTheme } from '../../../../theme';

const DeploymentReview = (props) => {
  const { thematicPackage } = props;
  return (
    <>
      <Typography align='center' variant='h5'>
        You are about to deploy thematic package with ID:
        {' '}
        {thematicPackage?.id}
        {' '}
        to eshop.
        <br />
        Review your changes before proceeding
      </Typography>
      <Paper style={ { padding: getTheme().spacing(4), margin: getTheme().spacing(3) } }>
        <Typography variant='body1'>
          Name:
          {' '}
          {thematicPackage?.name}
        </Typography>
        <Typography variant='body1'>
          Description:
          {' '}
          {thematicPackage?.description}
        </Typography>
        <Typography variant='body1'>
          Measurement Unit:
          {' '}
          {props.measurement_unit}
        </Typography>
        <Typography variant='body1'>
          Taxation:
          {' '}
          {props.tax}
        </Typography>
        <Typography variant='body1'>
          Accountic Category:
          {' '}
          {props.accounting_category}
        </Typography>
        <Typography variant='body1'>
          Barcode:
          {' '}
          {props.barcode}
        </Typography>
        <Typography variant='body1'>
          Thematic Group:
          {' '}
          {props.thematicgroup}
        </Typography>
        <Typography variant='body1'>
          Business Unit:
          {' '}
          {props.business_unit}
        </Typography>
        <Typography variant='body1'>
          Wholesale Price:
          {' '}
          {props.wholesale_price}
        </Typography>
        <Typography variant='body1'>
          Retail Price:
          {' '}
          {props.retail_price}
        </Typography>
      </Paper>
    </>
  );
};

export default DeploymentReview;
